import { useEffect, useState } from "react";
import { AthleticLogo, BTLogo } from "assets/icons/config";
import { useQuery } from "hooks/useQuery";
import Error from "components/Error";
import Form from "./components/Form";
import { Box, CircularProgress, Container, Grid } from "@mui/material";
import { useAuthToken } from "hooks/useAuthToken";
import { BODY_BRANDS, fnValidationRequest } from "./helpers/misc";

// services
import { getDocumentTypes } from "services/payments";

import { getAllCities } from "services/ApiGeneralService";
import { getInfoUserShoppingExpress } from "services/shoppingExpress";
import { ERROR_REFERENCES } from "./helpers/customTextLabels";

const ShoppingExpres = ({ setCurrentBrand }) => {
  const { getAuthToken } = useAuthToken();
  const query = useQuery();
  const currentBrand = query.get("b");
  const productId = query.get("prod");
  const promId = query.get("prom");
  const uuid = query.get("uuid");

  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [infoProduct, setInfoProduct] = useState({});
  const [infoUser, setInfoUser] = useState({});
  const [cities, setCities] = useState([]);
  const [messageError, setMessageError] = useState("");

  /*
    useEffect to initial for getting documents and cities
  */
  useEffect(() => {
    const fnInitialization = async () => {
      try {
        setLoading(true);
        localStorage.setItem("current_brand", currentBrand);
        setCurrentBrand(currentBrand);
        await getAuthToken();
        const { data: dataDocs } = await getDocumentTypes();
        const { data: dataCities } = await getAllCities();
        fnValidationRequest(dataDocs) && setDocuments(dataDocs.data);
        fnValidationRequest(dataCities) && setCities(dataCities.data);
        const { data } = await getInfoUserShoppingExpress(
          uuid,
          productId || promId,
          productId ? "prod" : "prom"
        );
        const { shopping_express_has_transaction: info } = data?.data;
        const { product } = data?.data;
        fnValidationRequest(data) && setInfoUser(info);
        fnValidationRequest(data) && setInfoProduct({ product: product?.name });
      } catch (err) {
        const { message } = err?.response?.data?.message[0];
        setMessageError(message || ERROR_REFERENCES);
      } finally {
        setLoading(false);
      }
    };
    fnInitialization();
  }, []);

  if (loading) {
    return (
      <Box
        maxWidth="100%"
        height="98vh"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="md" height="98vh">
      <Grid container spacing={2} py={{ xs: 2, md: 3 }} px={{ xs: 3, md: 12 }}>
        <Grid
          item
          xs={12}
          container
          justifyContent={{ xs: "center", md: "flex-start" }}
        >
          {BODY_BRANDS.includes(currentBrand) ? <BTLogo /> : <AthleticLogo />}
        </Grid>
      </Grid>
      {messageError ? (
        <Error
          message={messageError}
          customTitle={messageError}
          linkButton=""
        />
      ) : (
        <Form
          documents={documents}
          cities={cities}
          setInfoProduct={setInfoProduct}
          infoProduct={infoProduct}
          infoUser={infoUser}
          setMessageError={setMessageError}
        />
      )}
    </Container>
  );
};

export default ShoppingExpres;
